import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikInput } from 'components/UiKit/FormikFields';

const FieldNumber = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikInput
      placeholder="Enter field number"
      id="fieldNumber"
      name="fieldNumber"
      label="Field Number"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default FieldNumber;
